export default __webpack_public_path__ + "static/media/placeholder_dummy2016-nagelstudio01-de.125c63a8.png";